   
import React, { useEffect, useState } from "react";
import { data } from "../data/data";
import {
  Clear,
  ItemClose,
  ItemPanel,
  ItemText,
  StyledPanel,
} from "../styled/StyledPanel";

export const Panel = ({ idx, clearPanel }) => {

  const [skillData, setSkillData] = useState([]);

  const [arr, setArr] = useState(data);

  useEffect(() => {
    setSkillData(arr[idx].skills);
  },[]);
 

  return (
    <>
      <StyledPanel>
        <ItemPanel>
          <ItemText>{skillData[0]}</ItemText> <ItemClose>X</ItemClose>
        </ItemPanel>
        <ItemPanel>
          <ItemText>{skillData[1]} </ItemText>
          <ItemClose>X</ItemClose>
        </ItemPanel>
        <ItemPanel>
          <ItemText>{skillData[2]} </ItemText>
          <ItemClose>X</ItemClose>
        </ItemPanel>
        <ItemPanel>
          <ItemText>{skillData[3]} </ItemText>
          <ItemClose>X</ItemClose>
        </ItemPanel>
        <Clear onClick={clearPanel}>Clear</Clear>
      </StyledPanel>
    </>
  );
};